"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Configuration = __importStar(require("./components/configuration"));
const initialState = {
    inputProductId: "MLPZ55",
    selectedProductId: undefined,
    selectedProperties: undefined,
    selectedCurrency: undefined,
    selectedSalesOrg: undefined,
    results: false,
    variantProperties: "",
    showLoader: false
};
function Component(_props) {
    const [state, setState] = React.useState(initialState);
    const setInputProductId = (text) => setState(Object.assign(Object.assign({}, state), { inputProductId: text, selectedProductId: undefined }));
    const selectProductId = () => setState(Object.assign(Object.assign({}, state), { selectedProductId: state.inputProductId, selectedProperties: undefined, results: false }));
    const setShowResults = (show) => setState(Object.assign(Object.assign({}, state), { results: show }));
    const setProperties = (pvs) => setState(Object.assign(Object.assign({}, state), { selectedProperties: pvs, results: false }));
    const setCurrency = (id) => setState(Object.assign(Object.assign({}, state), { selectedCurrency: id, results: false }));
    const setSalesOrg = (id) => setState(Object.assign(Object.assign({}, state), { selectedSalesOrg: id, results: false }));
    const setVariantProperties = (text) => setState(Object.assign(Object.assign({}, state), { variantProperties: text }));
    const setLoader = (show) => setState(Object.assign(Object.assign({}, state), { showLoader: show }));
    return (React.createElement(React.Fragment, null,
        state.showLoader && (React.createElement(Elements.LoadingOverlay, null,
            React.createElement(Elements.Loader, null))),
        React.createElement(Elements.StandardContainer, null,
            React.createElement(Elements.FlexContainerRow, null,
                React.createElement(Elements.FlexContainerStack, { center: false },
                    React.createElement(Elements.FlexContainerRow, { center: false },
                        React.createElement(Elements.H3, null, "ProductId")),
                    React.createElement(Elements.FlexContainerRow, { center: false },
                        React.createElement(Elements.InputText, { value: state.inputProductId, onChange: e => setInputProductId(e.target.value), onKeyDown: e => e.keyCode === 13 && selectProductId() }),
                        React.createElement(Elements.StandardButton, { onClick: () => selectProductId() }, "OK")),
                    state.selectedProductId !== undefined && (React.createElement(Configuration.Component, { productId: state.selectedProductId, selectedProperties: state.selectedProperties, setProperties: setProperties, selectedCurrency: state.selectedCurrency, selectedSalesOrg: state.selectedSalesOrg, setCurrency: setCurrency, setSalesOrg: setSalesOrg, showResults: state.results, setShowResults: setShowResults, variantProperties: state.variantProperties, setVariantProperties: setVariantProperties, setLoader: setLoader })))))));
}
//# sourceMappingURL=component.js.map